import React, { useEffect } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

const MouseFollower = () => {
  // 1. Set up MotionValues to track mouse x and y position
  const cursorX = useMotionValue(-100);
  const cursorY = useMotionValue(-100);

  // 2. Create "spring" physics for the inner dot
  const springConfig = { damping: 25, stiffness: 200 };
  const cursorXSpring = useSpring(cursorX, springConfig);
  const cursorYSpring = useSpring(cursorY, springConfig);

  // 3. Create independent "spring" physics for the outer ring (slower for lag effect)
  const ringSpringConfig = { damping: 40, stiffness: 150 };
  const ringXSpring = useSpring(cursorX, ringSpringConfig);
  const ringYSpring = useSpring(cursorY, ringSpringConfig);

  useEffect(() => {
    const moveCursor = (e) => {
      // Offset by 8px to center the 16px (w-4) dot
      cursorX.set(e.clientX - 8);
      cursorY.set(e.clientY - 8);
    };

    window.addEventListener('mousemove', moveCursor);

    return () => {
      window.removeEventListener('mousemove', moveCursor);
    };
  }, [cursorX, cursorY]);

  return (
    <>
      {/* The animated follower circle */}
      <motion.div
        className="fixed top-0 left-0 w-4 h-4 bg-[#FF5733] rounded-full pointer-events-none z-[9999] mix-blend-multiply hidden md:block opacity-60"
        style={{
          translateX: cursorXSpring,
          translateY: cursorYSpring,
        }}
      />
      
      {/* The larger, fainter outer ring */}
       <motion.div
        className="fixed top-0 left-0 w-12 h-12 border-2 border-[#FF5733] rounded-full pointer-events-none z-[9998] hidden md:block opacity-20"
        style={{
            translateX: ringXSpring,
            translateY: ringYSpring,
            marginLeft: '-16px', // Offsets the larger size to center it
            marginTop: '-16px'
        }}
      />
    </>
  );
};

export default MouseFollower;